<template>
  <fragment>
  <li><a href="#home">Home</a></li>
  <li><a href="#portfolio">Portfolio</a></li>
  <li><a href="#skills">Skills</a></li>
  <li><a href="#timeline">Timeline</a></li>
  <li><a href="#price">Price</a></li>
  <li><a href="#news">News</a></li>
  <li><a href="#contact">Contact</a></li>
  </fragment>
</template>

<script>
export default {
  name: "Menu",
};
</script>